// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"98":"6be887cc","365":"2f07bed7","891":"fab8fcf8"}[chunkId] + ".js";
};